// extracted by mini-css-extract-plugin
export default {"genres-wrapper":"Genres_genres-wrapper__tm5ry"};